import { type MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import { formatCurrency } from '@/shared';
import { IEquipoServicioAdicionales } from '@/shared/interfaces';

type UseEquiposAdicionalesTableParams = {
  showItemPrice?: boolean;
};
export const useEquiposAdicionalesTable = ({
  showItemPrice = false,
}: UseEquiposAdicionalesTableParams = {}) => {
  const columnsEquiposAdicionalesAgenda = useMemo<
    MRT_ColumnDef<IEquipoServicioAdicionales>[]
  >(
    () =>
      [
        {
          accessorKey: 'descripcion',
          header: 'Descripción',
          size: 200,
        },
        {
          accessorKey: 'cantidad',
          header: 'Cantidad',
          size: 80,
        },

        showItemPrice
          ? {
            accessorKey: 'precio_1',
            header: 'Precio',
            size: 80,
            Cell: ({ row }: any) =>
              row.original?.precios
                ? formatCurrency(row.original?.precios[0].precio)
                : 'N/A',
          }
          : null,

        {
          accessorKey: 'cuotas',
          header: 'Núm. Cuotas',
          size: 80,
        },

      ].filter(Boolean) as MRT_ColumnDef<IEquipoServicioAdicionales>[],
    []
  );

  return {
    columnsEquiposAdicionalesAgenda,
  };
};
